import { createSlice } from '@reduxjs/toolkit';
export const initialExperimentsState = {};
export const experimentsSlice = createSlice({
    name: 'experiments',
    initialState: initialExperimentsState,
    reducers: {
        setExperimentVariant: (state, action) => {
            state[action.payload.name] = action.payload.variant;
        },
    },
});
export const { setExperimentVariant } = experimentsSlice.actions;
export const experimentVariantSelector = (state, experimentName) => state.features.experiments[experimentName];
export default experimentsSlice.reducer;
//# sourceMappingURL=experimentsSlice.js.map